<template>
  <div class="page">
    <PageHeader>
      <div slot="left"></div>
    </PageHeader>

    <div class="d-flex flex-column align-center mt-16">
      <div class="mb-6 text-h5">{{ $t('Select a group') }}</div>
      <div class="d-flex flex-column">
        <v-btn
          v-for="group in groups"
          :key="group.name"
          class="mb-1"
          @click="selectGroup(group.name)"
        >
          {{ group.name }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

import PageHeader from '@/globals/components/PageHeader.vue';

export default {
  components: {
    PageHeader,
  },
  computed: {
    groups() {
      return this.$store.state.authentication.user.groups;
    },
  },
  methods: {
    selectGroup(groupName) {
      this.$store.commit('setGroup', groupName);
      this.$router.push({
        name: 'member-list',
        params: { groupName },
      });
    },
  },
};
</script>

<style>
  .logo {
    max-width: 80%;
    width: 200px;
  }
</style>
